import { css, cx } from "@emotion/css"

type TableProps = {
  title?: string | JSX.Element
  width?: string
  hideBorder?: boolean
  isLarge?: boolean
  customWidth?: number
}
export function CustomTitle(props: TableProps) {
  const { title, hideBorder, isLarge, customWidth } = props

  return (
    <div
      style={{
        height: 40,
        width: customWidth ? customWidth : isLarge ? 560 : 320,
        fontSize: 14,
        borderBottom: `${
          hideBorder ? "" : "1px solid var(--primary-main-light-green)"
        }`,
        textAlign: "center",
        color: "var(--white)",
      }}
      className={
        hideBorder ? cx("HeadingH5bBold") : cx("HeadingH5bBold", styles.border)
      }
    >
      {title}
    </div>
  )
}
const styles = {
  border: css`
    border-bottom: 1px solid var(--primary-main-light-green);
  `,
}
